export default "__VITE_ASSET__941a6181__"